export const translations = {
  en: {
    // Header
    companyName: "HUNG PUMP",
    title: "Total Dynamic Head (TDH) Calculator",
    description: "This calculator determines the Total Dynamic Head (TDH) for pump selection, including static head, friction losses (using Hazen-Williams equation), pressure head, and velocity head. It also includes equivalent lengths from fittings using K-values.",
    
    // Section Headers
    pipeFlowParameters: "Pipe & Flow Parameters",
    elevationPressure: "Elevation & Pressure",
    optionalFittings: "Optional Fittings",
    results: "Results",
    
    // Input Labels
    flowRate: "Flow Rate",
    pipeDiameter: "Pipe Diameter",
    pipeLength: "Pipe Length",
    pipeMaterial: "Pipe Material (Hazen-Williams C-Factor)",
    suctionElevation: "Suction Elevation",
    dischargeElevation: "Discharge Elevation",
    suctionPressure: "Suction Pressure (optional)",
    dischargePressure: "Discharge Pressure (optional)",
    elevationUnit: "Elevation Unit",
    pressureUnit: "Pressure Unit",
    
    // Units
    flowUnit: "Flow Unit",
    diameterUnit: "Diameter Unit",
    lengthUnit: "Length Unit",
    
    // Pressure Units
    "bar": "bar",
    "psi": "psi",
    "kPa": "kPa",
    "mH2O": "meters H2O",
    
    // Flow Units
    "m³/s": "m³/s",
    "m³/hr": "m³/hr",
    "GPM": "GPM",
    "LPM": "LPM",
    
    // Diameter Units
    "mm": "mm",
    "inch": "inch",
    
    // Length Units
    "meters": "meters",
    "millimeters": "millimeters",
    "feet": "feet",
    
    // Pipe Materials
    materials: {
      "New Steel/Iron (C=150)": "New Steel/Iron (C=150)",
      "New PVC/Plastic (C=140)": "New PVC/Plastic (C=140)",
      "HDPE - New (C=150)": "HDPE - New (C=150)",
      "HDPE - Used (C=140)": "HDPE - Used (C=140)",
      "Galvanized Iron - New (C=120)": "Galvanized Iron - New (C=120)",
      "Galvanized Iron - Used (C=100)": "Galvanized Iron - Used (C=100)",
      "Ductile Iron - New (C=130)": "Ductile Iron - New (C=130)",
      "Ductile Iron - Used (C=120)": "Ductile Iron - Used (C=120)",
      "Cast Iron - New (C=130)": "Cast Iron - New (C=130)",
      "Cast Iron - 10 years (C=110)": "Cast Iron - 10 years (C=110)",
      "Cast Iron - 20 years (C=100)": "Cast Iron - 20 years (C=100)",
      "Cast Iron - 30 years (C=90)": "Cast Iron - 30 years (C=90)",
      "Cast Iron - 40 years (C=80)": "Cast Iron - 40 years (C=80)",
      "Fire Hose - New (C=140)": "Fire Hose - New (C=140)",
      "Fire Hose - Used (C=130)": "Fire Hose - Used (C=130)",
      "Garden Hose - Rubber (C=100)": "Garden Hose - Rubber (C=100)",
      "Industrial Hose - New (C=130)": "Industrial Hose - New (C=130)"
    },
    
    // Fittings
    fittings: {
      elbows90: "90° Elbows",
      elbows45: "45° Elbows",
      teeThrough: "Tee (Through)",
      teeBranch: "Tee (Branch)",
      gateValve: "Gate Valves",
      globeValve: "Globe Valves",
      checkValve: "Check Valves"
    },
    
    // Button
    calculateButton: "Calculate Head Loss",
    
    // Results
    flowVelocity: "Flow Velocity (v)",
    staticHead: "Static Head (Hs)",
    frictionHead: "Friction Head Loss (hf)",
    pressureHead: "Pressure Head (Hp)",
    velocityHead: "Velocity Head (Hv)",
    totalDynamicHead: "Total Dynamic Head (TDH)",
    equivalentLength: "Equivalent Length from Fittings",
    
    // Units in results
    velocityUnit: "m/s",
    headLossUnit: "meters",
    lengthResultUnit: "meters",
    
    // Error
    errorMessage: "Please enter valid positive numbers for flow and diameter.",
    
    // Language
    language: "Language",
    english: "English",
    chinese: "繁體中文"
  },
  
  zh: {
    // Header
    companyName: "宏泵集團",
    title: "總動態揚程 (TDH) 計算器",
    description: "此計算器用於泵浦選型，計算總動態揚程（TDH），包括靜態揚程、摩擦損失（使用海曾-威廉方程式）、壓力揚程和速度揚程。它還包括使用K值的管件等效長度。",
    
    // Section Headers
    pipeFlowParameters: "管路與流量參數",
    elevationPressure: "高程與壓力",
    optionalFittings: "選用管件",
    results: "計算結果",    // Input Labels
    flowRate: "流量",
    pipeDiameter: "管徑",
    pipeLength: "管長",
    pipeMaterial: "管材（海曾-威廉C係數）",
    suctionElevation: "吸入端高程",
    dischargeElevation: "排出端高程",
    suctionPressure: "吸入端壓力（選填）",
    dischargePressure: "排出端壓力（選填）",
    elevationUnit: "高程單位",
    pressureUnit: "壓力單位",
    
    // Units
    flowUnit: "流量單位",
    diameterUnit: "管徑單位",
    lengthUnit: "長度單位",
    
    // Pressure Units
    "bar": "巴",
    "psi": "磅/平方英吋",
    "kPa": "千帕",
    "mH2O": "米水柱",
    
    // Flow Units
    "m³/s": "立方公尺/秒",
    "m³/hr": "立方公尺/小時",
    "GPM": "加侖/分鐘",
    "LPM": "公升/分鐘",
    
    // Diameter Units
    "mm": "公釐",
    "inch": "英吋",
    
    // Length Units
    "meters": "公尺",
    "millimeters": "公釐",
    "feet": "英呎",
    
    // Pipe Materials
    materials: {
      "New Steel/Iron (C=150)": "新鋼鐵管 (C=150)",
      "New PVC/Plastic (C=140)": "新PVC/塑膠管 (C=140)",
      "HDPE - New (C=150)": "HDPE新管 (C=150)",
      "HDPE - Used (C=140)": "HDPE舊管 (C=140)",
      "Galvanized Iron - New (C=120)": "鍍鋅鐵管-新 (C=120)",
      "Galvanized Iron - Used (C=100)": "鍍鋅鐵管-舊 (C=100)",
      "Ductile Iron - New (C=130)": "球墨鑄鐵管-新 (C=130)",
      "Ductile Iron - Used (C=120)": "球墨鑄鐵管-舊 (C=120)",
      "Cast Iron - New (C=130)": "鑄鐵管-新 (C=130)",
      "Cast Iron - 10 years (C=110)": "鑄鐵管-10年 (C=110)",
      "Cast Iron - 20 years (C=100)": "鑄鐵管-20年 (C=100)",
      "Cast Iron - 30 years (C=90)": "鑄鐵管-30年 (C=90)",
      "Cast Iron - 40 years (C=80)": "鑄鐵管-40年 (C=80)",
      "Fire Hose - New (C=140)": "消防水帶-新 (C=140)",
      "Fire Hose - Used (C=130)": "消防水帶-舊 (C=130)",
      "Garden Hose - Rubber (C=100)": "橡膠花園水管 (C=100)",
      "Industrial Hose - New (C=130)": "工業水管-新 (C=130)"
    },
    
    // Fittings
    fittings: {
      elbows90: "90度彎頭",
      elbows45: "45度彎頭",
      teeThrough: "三通（直通）",
      teeBranch: "三通（支管）",
      gateValve: "閘閥",
      globeValve: "球閥",
      checkValve: "止回閥"
    },
    
    // Button
    calculateButton: "計算水頭損失",
    
    // Results
    flowVelocity: "流速 (v)",
    staticHead: "靜態揚程 (Hs)",
    frictionHead: "摩擦水頭損失 (hf)",
    pressureHead: "壓力揚程 (Hp)",
    velocityHead: "速度揚程 (Hv)",
    totalDynamicHead: "總動態揚程 (TDH)",
    equivalentLength: "管件等效長度",
    
    // Units in results
    velocityUnit: "公尺/秒",
    headLossUnit: "公尺",
    lengthResultUnit: "公尺",
    
    // Error
    errorMessage: "請輸入有效的正數流量和管徑。",
    
    // Language
    language: "語言",
    english: "English",
    chinese: "繁體中文"
  }
};
